module.exports = __webpack_public_path__ + "media/images/flavours/icon-epice_dark-cc4f9f997dc276f4f6e7e49118de2fae.png";